import moment from "moment";
import { GetServerSidePropsContext } from "next";
import nookies, { parseCookies } from "nookies";
import { postRefreshToken } from "./auth";
import axios from "axios";
import { wallet_provider_key } from "../config";

export const endpointOrigin =
  process.env.NEXT_PUBLIC_STATE === "development"
    ? `${process.env.NEXT_PUBLIC_HOST}/${process.env.NEXT_PUBLIC_API_URL}/managements/${process.env.NEXT_PUBLIC_API_VERSION}`
    : `/${process.env.NEXT_PUBLIC_API_URL}/managements/${process.env.NEXT_PUBLIC_API_VERSION}`;

export const Timeout = (time: number) => {
  let controller = new AbortController();
  setTimeout(() => controller.abort(), time * 1000);
  return controller;
};

export const refreshFunction = async (
  pathUrl: string,
  option: any,
  ctx?: GetServerSidePropsContext,
  urlOrigin?: string
) => {
  const allCookie = ctx ? parseCookies(ctx) : parseCookies();
  const rsRefreshToken: any = await postRefreshToken(
    allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any],
    urlOrigin ? urlOrigin : undefined
  );

  if (rsRefreshToken.code === 200) {
    nookies.set(
      ctx ? ctx : null,
      process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
      rsRefreshToken.result.refreshToken,
      {
        path: "/",
        expires: moment().add(7, "days").toDate(),
        sameSite: "strict",
      }
    );
    nookies.set(
      ctx ? ctx : null,
      process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
      rsRefreshToken.result.accessToken,
      {
        path: "/",
        expires: moment().add(7, "days").toDate(),
        sameSite: "strict",
      }
    );

    return fetch(pathUrl, {
      ...option,
      headers: {
        ...option.headers,
        Authorization: `Bearer ${rsRefreshToken.result.accessToken}`,
      },
    })
      .then(async (response) => {
        try {
          return response.status === 401
            ? { code: response.status }
            : { code: response.status, result: await response.json() };
        } catch (error) {
          return { code: response.status };
        }
      })
      .then((result) => {
        return result;
      })
      .catch((error: TypeError) => {
        return error;
      });
  } else {
    nookies.destroy(null, process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any, {
      path: "/",
    });
    nookies.destroy(
      null,
      process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
      {
        path: "/",
      }
    );
    nookies.destroy(null, wallet_provider_key, {
      path: "/",
    });
    return { code: 401 };
  }
};

export const refreshFunctionAxios = async (
  pathUrl: string,
  option: any,
  ctx?: GetServerSidePropsContext,
  urlOrigin?: string
) => {
  const allCookie = ctx ? parseCookies(ctx) : parseCookies();
  const rsRefreshToken: any = await postRefreshToken(
    allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any],
    urlOrigin ? urlOrigin : undefined
  );

  if (rsRefreshToken.code === 200) {
    nookies.set(
      ctx ? ctx : null,
      process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
      rsRefreshToken.result.refreshToken,
      {
        path: "/",
        expires: moment().add(7, "days").toDate(),
        sameSite: "strict",
      }
    );
    nookies.set(
      ctx ? ctx : null,
      process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
      rsRefreshToken.result.accessToken,
      {
        path: "/",
        expires: moment().add(7, "days").toDate(),
        sameSite: "strict",
      }
    );

    return axios({
      ...option,
      headers: {
        ...option.headers,
        Authorization: `Bearer ${rsRefreshToken.result.accessToken}`,
      },
    })
      .then(async (response) => {
        try {
          return response.status === 401
            ? { code: response.status }
            : { code: response.status, result: response.data };
        } catch (error) {
          return { code: response.status };
        }
      })
      .then((result) => {
        return result;
      })
      .catch((error: TypeError) => {
        return error;
      });
  } else {
    nookies.destroy(null, process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any, {
      path: "/",
    });
    nookies.destroy(
      null,
      process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
      {
        path: "/",
      }
    );
    nookies.destroy(null, wallet_provider_key, {
      path: "/",
    });
    return { code: 401 };
  }
};
